
import styles from "./styles.module.css"



import { CgDollar } from "react-icons/cg"

import { useState } from "react"
import { doc, updateDoc } from 'firebase/firestore'
import { database } from "../../../services/firebase-config"
import Loading from "../../Loading"


export default function BookMakeFreeButton({ collection, bookId, isVirtual, updateTableData }) {

    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    async function paidBook(docCollection, docId) {
        setIsLoading(true);
        const documentRef = doc(database, docCollection, docId);
        await updateDoc(documentRef, { free: false })
        setModal(false);
        setIsLoading(false);
        updateTableData();
    }


    return (<>
        <button title="Tornar pago" className={styles.removeButton} onClick={() => { setModal(true) }}>
            <CgDollar />
        </button>

        {modal &&
            <div className={styles.modalContainer}>
                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2 className={styles.modalCard__title}>Tornar pago</h2>
                    <p className={styles.modalCard__alert}>Tem certeza que deseja deixar este item <strong>pago</strong> ?</p>
                    <div className={styles.modalCard__buttonsContainer}>
                        <button onClick={() => { setModal(false) }} className={styles.modalCard__closeButton}>Fechar</button>
                        <button onClick={() => { paidBook(collection, bookId) }} className={styles.modalCard__deleteButton}>Confirmar</button>
                    </div>
                </div>
            </div>
        }

    </>);
}